import { Container } from '@mui/material';
import { motion } from 'framer-motion';

import HeroBackground from './HeroBackground';
import HeroArchitecture from './HeroArchitecture';

const HIGHLIGHTS = ['정부 최초 MCP 서버 구축', 'LLM AI Agent', '공공데이터 개방'];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.1 } },
};
const item = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
};

/**
 * AI 랜딩 히어로.
 * 좌측 카피 + 우측 통합 아키텍처 다이어그램(랜딩의 5개 주제를 한 장에 아우름).
 * 배경에는 은은한 뉴럴넷 컨스텔레이션을 깔아 'AI/테크' 인상을 강화한다.
 */
export default function AiHero() {
  return (
    <header className="ai-hero">
      <HeroBackground />

      <Container maxWidth="xl" className="ai-hero__content">
        <div className="ai-hero__grid">
          <motion.div className="ai-hero__copy" variants={container} initial="hidden" animate="show">
            <motion.span className="ai-hero__eyebrow" variants={item}>
              AI INFRASTRUCTURE
            </motion.span>

            <motion.h1 className="ai-hero__title" variants={item}>
              데이터 개방을 넘어,
              <br />
              <span className="ai-grad">
                AI로 공공서비스를
                <br />
                혁신
              </span>
              합니다
            </motion.h1>

            <motion.p className="ai-hero__sub" variants={item}>
              <b>정부 최초 MCP 서버 구축</b> 및 공공서비스 연계 PoC를 수행하며,
              <br />
              <b>LLM 기반 AI Agent 시스템</b>의 전문성을 확장하고 있습니다.
            </motion.p>

            <motion.div className="ai-hero__highlights" variants={item}>
              {HIGHLIGHTS.map((h, i) => (
                <span key={h} className="ai-hero__hl">
                  {i > 0 && <i className="ai-hero__hl-sep" />}
                  {h}
                </span>
              ))}
            </motion.div>
          </motion.div>

          <motion.div
            className="ai-hero__arch"
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.9, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
          >
            <HeroArchitecture />
          </motion.div>
        </div>
      </Container>

      <div className="ai-hero__scroll" aria-hidden>
        <span>SCROLL</span>
        <span />
      </div>
    </header>
  );
}
